import { ColumnsModel } from "@syncfusion/ej2-react-querybuilder";
import {
  equalOperator,
  isNotNullOperator,
  isNullOperator,
  notEqualOperator,
} from ".";

export class StringColumn {
  constructor(private column: ColumnsModel) { }

  Operator = [
    equalOperator,
    notEqualOperator,
    isNullOperator,
    isNotNullOperator,
  ];

  ToColumn(): ColumnsModel {
    return {
      ...this.column,
      operators: this.Operator,
    };
  }
}
